(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/* global Y */
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function extend(Y) {
  var YArray = function () {
    function YArray(os, _model, _content) {
      var _this = this;

      _classCallCheck(this, YArray);

      this.os = os;
      this._model = _model;
      // Array of all the neccessary content
      this._content = _content;
      this.eventHandler = new Y.utils.EventHandler(function (op) {
        if (op.struct === 'Insert') {
          var pos = void 0;
          // we check op.left only!,
          // because op.right might not be defined when this is called
          if (op.left === null) {
            pos = 0;
          } else {
            pos = 1 + _this._content.findIndex(function (c) {
              return Y.utils.compareIds(c.id, op.left);
            });
            if (pos <= 0) {
              throw new Error('Unexpected operation!');
            }
          }
          var values;
          var length;
          if (op.hasOwnProperty('opContent')) {
            (function () {
              _this._content.splice(pos, 0, {
                id: op.id,
                type: op.opContent
              });
              var opContent = op.opContent;
              length = 1;
              values = function values() {
                return new Promise(function (resolve) {
                  _this.os.requestTransaction(regeneratorRuntime.mark(function _callee() {
                    var type;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            return _context.delegateYield(this.getType(opContent), 't0', 1);

                          case 1:
                            type = _context.t0;

                            resolve([type]);

                          case 3:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, this);
                  }));
                });
              };
            })();
          } else {
            var contents = op.content.map(function (c, i) {
              return {
                id: [op.id[0], op.id[1] + i],
                val: c
              };
            });
            // insert value in _content
            _this._content.splice.apply(_this._content, [pos, 0].concat(contents));
            values = op.content;
            length = op.content.length;
          }
          _this.eventHandler.callEventListeners({
            type: 'insert',
            object: _this,
            index: pos,
            values: values,
            // valueId: valueId, // TODO: does this still work as expected?
            length: length
          });
        } else if (op.struct === 'Delete') {
          var i = 0; // current position in _content
          for (; i < _this._content.length && op.length > 0; i++) {
            var c = _this._content[i];
            if (Y.utils.inDeletionRange(op, c.id)) {
              // is in deletion range!
              var delLength;
              // check how many character to delete in one flush
              for (delLength = 1; delLength < op.length && i + delLength < _this._content.length && Y.utils.inDeletionRange(op, _this._content[i + delLength].id); delLength++) {}
              // last operation thas will be deleted
              c = _this._content[i + delLength - 1];
              // update delete operation
              op.length -= c.id[1] - op.target[1] + 1;
              op.target = [c.id[0], c.id[1] + 1];
              // apply deletion & find send event
              var content = _this._content.splice(i, delLength);
              // TODO: how about return types
              var _values = content.map(function (c) {
                return c.val;
              });
              _this.eventHandler.callEventListeners({
                type: 'delete',
                object: _this,
                index: i,
                values: _values,
                _content: content,
                length: delLength
              });
              // with the fresh delete op, we can continue
              // note: we don't have to increment i, because the i-th content was deleted
              // but on the other had, the (i+delLength)-th was not in deletion range
              // So we don't do i--
            }
          }
        } else {
            throw new Error('Unexpected struct!');
          }
      });
    }

    _createClass(YArray, [{
      key: '_destroy',
      value: function _destroy() {
        this.eventHandler.destroy();
        this.eventHandler = null;
        this._content = null;
        this._model = null;
        this.os = null;
      }
    }, {
      key: 'get',
      value: function get(pos) {
        var _this2 = this;

        if (pos == null || typeof pos !== 'number') {
          throw new Error('pos must be a number!');
        }
        if (pos >= this._content.length) {
          return undefined;
        }
        if (this._content[pos].type == null) {
          return this._content[pos].val;
        } else {
          var oid = this._content[pos].type;
          return new Promise(function (resolve) {
            _this2.os.requestTransaction(regeneratorRuntime.mark(function _callee2() {
              var type;
              return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      return _context2.delegateYield(this.getType(oid), 't0', 1);

                    case 1:
                      type = _context2.t0;

                      resolve(type);

                    case 3:
                    case 'end':
                      return _context2.stop();
                  }
                }
              }, _callee2, this);
            }));
          });
        }
      }
      // only returns primitive values

    }, {
      key: 'toArray',
      value: function toArray() {
        return this._content.map(function (x, i) {
          return x.val;
        });
      }
    }, {
      key: 'push',
      value: function push(contents) {
        return this.insert(this._content.length, contents);
      }
    }, {
      key: 'insert',
      value: function insert(pos, contents) {
        if (typeof pos !== 'number') {
          throw new Error('pos must be a number!');
        }
        if (!(contents instanceof Array)) {
          throw new Error('contents must be an Array of objects!');
        }
        if (contents.length === 0) {
          return;
        }
        if (pos > this._content.length || pos < 0) {
          throw new Error('This position exceeds the range of the array!');
        }
        var mostLeft = pos === 0 ? null : this._content[pos - 1].id;

        var ops = [];
        var newTypes = [];
        var prevId = mostLeft;
        for (var i = 0; i < contents.length;) {
          var op = {
            left: prevId,
            origin: prevId,
            // right: mostRight,
            // NOTE: I intentionally do not define right here, because it could be deleted
            // at the time of inserting this operation (when we get the transaction),
            // and would therefore not defined in this._content
            parent: this._model,
            struct: 'Insert'
          };
          var _content = [];
          var typeDefinition;
          while (i < contents.length) {
            var val = contents[i++];
            typeDefinition = Y.utils.isTypeDefinition(val);
            if (!typeDefinition) {
              _content.push(val);
            } else if (_content.length > 0) {
              i--; // come back again later
              break;
            } else {
              break;
            }
          }
          if (_content.length > 0) {
            // content is defined
            op.content = _content;
            op.id = this.os.getNextOpId(_content.length);
          } else {
            // otherwise its a type
            var typeid = this.os.getNextOpId(1);
            newTypes.push([typeDefinition, typeid]);
            op.opContent = typeid;
            op.id = this.os.getNextOpId(1);
          }
          ops.push(op);
          prevId = op.id;
        }
        var eventHandler = this.eventHandler;
        this.os.requestTransaction(regeneratorRuntime.mark(function _callee3() {
          var mostRight, ml, i, j, op;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!(mostLeft != null)) {
                    _context3.next = 6;
                    break;
                  }

                  return _context3.delegateYield(this.getInsertionCleanEnd(mostLeft), 't0', 2);

                case 2:
                  ml = _context3.t0;

                  mostRight = ml.right;
                  _context3.next = 8;
                  break;

                case 6:
                  return _context3.delegateYield(this.getOperation(ops[0].parent), 't1', 7);

                case 7:
                  mostRight = _context3.t1.start;

                case 8:
                  i = 0;

                case 9:
                  if (!(i < newTypes.length)) {
                    _context3.next = 14;
                    break;
                  }

                  return _context3.delegateYield(this.createType.apply(this, newTypes[i]), 't2', 11);

                case 11:
                  i++;
                  _context3.next = 9;
                  break;

                case 14:
                  for (j = 0; j < ops.length; j++) {
                    op = ops[j];

                    op.right = mostRight;
                  }
                  return _context3.delegateYield(eventHandler.awaitOps(this, this.applyCreatedOperations, [ops]), 't3', 16);

                case 16:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));
        eventHandler.awaitAndPrematurelyCall(ops);
      }
    }, {
      key: 'delete',
      value: function _delete(pos, length) {
        if (length == null) {
          length = 1;
        }
        if (typeof length !== 'number') {
          throw new Error('length must be a number!');
        }
        if (typeof pos !== 'number') {
          throw new Error('pos must be a number!');
        }
        if (pos + length > this._content.length || pos < 0 || length < 0) {
          throw new Error('The deletion range exceeds the range of the array!');
        }
        if (length === 0) {
          return;
        }
        var eventHandler = this.eventHandler;
        var dels = [];
        for (var i = 0; i < length; i = i + delLength) {
          var targetId = this._content[pos + i].id;
          var delLength;
          // how many insertions can we delete in one deletion?
          for (delLength = 1; i + delLength < length; delLength++) {
            if (!Y.utils.compareIds(this._content[pos + i + delLength].id, [targetId[0], targetId[1] + delLength])) {
              break;
            }
          }
          dels.push({
            target: targetId,
            struct: 'Delete',
            length: delLength
          });
        }
        eventHandler.awaitAndPrematurelyCall(dels);
        this.os.requestTransaction(regeneratorRuntime.mark(function _callee4() {
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  return _context4.delegateYield(eventHandler.awaitOps(this, this.applyCreatedOperations, [dels]), 't0', 1);

                case 1:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));
      }
    }, {
      key: 'observe',
      value: function observe(f) {
        this.eventHandler.addEventListener(f);
      }
    }, {
      key: 'unobserve',
      value: function unobserve(f) {
        this.eventHandler.removeEventListener(f);
      }
    }, {
      key: '_changed',
      value: regeneratorRuntime.mark(function _changed(transaction, op) {
        var l, left;
        return regeneratorRuntime.wrap(function _changed$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (op.deleted) {
                  _context5.next = 13;
                  break;
                }

                if (!(op.struct === 'Insert')) {
                  _context5.next = 12;
                  break;
                }

                l = op.left;

              case 3:
                if (!(l != null)) {
                  _context5.next = 11;
                  break;
                }

                return _context5.delegateYield(transaction.getInsertion(l), 't0', 5);

              case 5:
                left = _context5.t0;

                if (left.deleted) {
                  _context5.next = 8;
                  break;
                }

                return _context5.abrupt('break', 11);

              case 8:
                l = left.left;
                _context5.next = 3;
                break;

              case 11:
                op.left = l;

              case 12:
                this.eventHandler.receivedOp(op);

              case 13:
              case 'end':
                return _context5.stop();
            }
          }
        }, _changed, this);
      })
    }, {
      key: 'length',
      get: function get() {
        return this._content.length;
      }
    }]);

    return YArray;
  }();

  Y.extend('Array', new Y.utils.CustomType({
    name: 'Array',
    class: YArray,
    struct: 'List',
    initType: regeneratorRuntime.mark(function YArrayInitializer(os, model) {
      var _content;

      return regeneratorRuntime.wrap(function YArrayInitializer$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _content = [];
              return _context6.delegateYield(Y.Struct.List.map.call(this, model, function (op) {
                if (op.hasOwnProperty('opContent')) {
                  _content.push({
                    id: op.id,
                    type: op.opContent
                  });
                } else {
                  op.content.forEach(function (c, i) {
                    _content.push({
                      id: [op.id[0], op.id[1] + i],
                      val: op.content[i]
                    });
                  });
                }
              }), 't0', 2);

            case 2:
              return _context6.abrupt('return', new YArray(os, model.id, _content));

            case 3:
            case 'end':
              return _context6.stop();
          }
        }
      }, YArrayInitializer, this);
    })
  }));
}

module.exports = extend;
if (typeof Y !== 'undefined') {
  extend(Y);
}

},{}]},{},[1])

